export const statusOrder = [
    { value: 0, label: 'annulé', classe: 'bg-danger', icon: 'fa-thumbs-o-down' },
    { value: 1, label: 'en attente', classe: 'bg-info',icon: 'fa-hourglass-half' },
    { value: 2, label: 'à préparer', classe: 'bg-primary', icon:'fa-hand-lizard-o' },
    { value: 3, label: 'en préparation', classe: 'bg-warning', icon: 'fa-hand-rock-o' },
    { value: 4, label: 'prête', classe: 'bg-success', icon: 'fa-thumbs-o-up' },
    { value: 5, label: 'livré', classe: 'bg-secondary', icon: 'fa-thumbs-o-up' }
]
export const statusPaiement = [
    { value: 0, label: 'en attente de paiement', classe: 'bg-info' },
    { value: 1, label: 'paiement accepté', classe: 'bg-success' },
    { value: 2, label: 'paiement refusé', classe: 'bg-warning' },
    { value: 3, label: 'paiement annulé', classe: 'bg-danger' },
    { value: 4, label: 'paiement remboursé', classe: 'bg-success' }
]
